import { defineStore } from 'pinia'
import { ref, reactive, toRaw } from 'vue'

export const useExportAndImportStore = defineStore('useExportAndImport', () => {
  const exportVisible = ref(false)
  let importProps = reactive({
    open: false,
    tableCode: '',
    reload: null,
    extraData: null
  })
  const initialData = { ...toRaw(importProps) }
  // 修改导出弹窗状态
  function showExportDialog(bool: boolean) {
    exportVisible.value = bool
  }
  function changeImportVisible(data: Record<string, string | boolean | Function>) {
    importProps = Object.assign(importProps, data)
  }
  function resetImportData() {
    importProps = Object.assign(importProps, initialData)
    return Promise.resolve()
  }

  return {
    exportVisible,
    importProps,
    showExportDialog,
    changeImportVisible,
    resetImportData
  }
})
